import React, { useState } from 'react'

function RoleApplication() {

  const roles = [1,2,3]
  const [inputValue, setInputValue] = useState("")
  return (
    <div className='bg-nightModeDark_200 my-[60px] text-white px-4 py-6 rounded-md'>
      <p className='my-5 font-semibold'>The project is currently seeking a legal advisor, to apply simply click the apply button</p>

      <div className='my-12'>
        <h3 className='font-bold text-2xl my-4'>Available Roles</h3>

        {roles.map((item) => {
          return (
            <div key={item} className='flex justify-between my-10'>
                <div className='space-y-6'>
                  <p className='font-medium text-lg'>Role</p>
                  <p className='italic'>Requirements.</p>
                </div>
                <div className=''>
                  <button className='transition-all ease-linear hover:translate-x-[5px]  bg-greenCustom text-white px-4 py-2 rounded-md'>
                    Apply
                  </button>
                </div>
          </div>  
          )
        })}



        <div className='my-5 space-y-3'>
                <p className='font-semibold'>Note:</p>
                <textarea 
                className='text-black font-semibold w-full mb-5 px-4 py-3 rounded-md'
                rows={7}
                value={inputValue}
                onChange={(e) => {
                    setInputValue(e.target.value)
                }}
                >
                </textarea>
            </div>

            <div className='flex w-full justify-end'>
            <button className='transition-all ease-linear hover:-translate-x-[5px]  w-2/5 mr-3 bg-greenCustom text-white px-8 rounded-md py-2'>
                Send
                </button>
            </div>

      </div>
    </div>
  )
}

export default RoleApplication
